import { ReactNode, createContext, useContext, useMemo } from 'react';
import { UploadControl, useUploadController } from 'src/components/upload';

type ContextState = {
  control: UploadControl;
};

const context = createContext<ContextState>(null as any);

export const useFileUploadContext = () => useContext(context);

export const FileUploadContextProvider = ({
  children,
}: { children: ReactNode }) => {
  const control = useUploadController();

  const value = useMemo(() => ({ control }), [control]);

  return <context.Provider value={value}>{children}</context.Provider>;
};
